import React from 'react';

const DemoSearchHeader = () => {
  return (
    <div className="demoSearchHeader">
      <span className="demoHeaderText">
        2. Use the search, to find saved tweets.
      </span>
    </div>
  );
};

export default DemoSearchHeader;